import * as React from "react";
import InsuranceInfoStatus from "../commons/model/InsuranceInfoStatus";

namespace InsuranceInfoStatusUtils {
  export const getStatusTypeI18nKey = function (status: InsuranceInfoStatus) {
    switch (status) {
      case InsuranceInfoStatus.NOT_STARTED:
        return "Global.Status.not_started";
      case InsuranceInfoStatus.UPDATED:
        return "Global.Status.updated";
      case InsuranceInfoStatus.PROCESSED:
        return "Global.Status.processed";
      case InsuranceInfoStatus.NO_INSURANCE:
        return "Global.Status.no_insurance";
    }
  };

  export function renderStatus(status: InsuranceInfoStatus) {
    return <span>{i18n[getStatusTypeI18nKey(status)]}</span>;
  }
}

export default InsuranceInfoStatusUtils;
